import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { captureAttribution } from "@/lib/attribution";
import { Nav } from "@/components/Nav";
import { MobileCTA } from "@/components/MobileCTA";
import { Hero } from "@/sections/Hero";
import { Ticker } from "@/components/Ticker";
import { Manifesto } from "@/sections/Manifesto";
import { Letter } from "@/sections/Letter";
import { Audience } from "@/sections/Audience";
import { Roadmap } from "@/sections/Roadmap";
import { Curriculum } from "@/sections/Curriculum";
import { Host } from "@/sections/Host";
import { Transformation } from "@/sections/Transformation";
import { Takeaways } from "@/sections/Takeaways";
import { FAQ } from "@/sections/FAQ";
import { FinalRegister } from "@/sections/FinalRegister";
import { Footer } from "@/sections/Footer";

gsap.registerPlugin(ScrollTrigger);

export default function Landing() {
  const heroRef = useRef(null);

  useEffect(() => {
    captureAttribution();
  }, []);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain" data-testid="landing-page">
      <a
        href="#register"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-[var(--accent)] focus:text-[var(--background-deep)] focus:px-4 focus:py-2 focus:rounded-[4px]"
      >
        Skip to registration
      </a>
      <Nav />
      <main>
        <Hero ref={heroRef} />
        <Ticker />
        <Manifesto />
        <Letter />
        <Audience />
        <Roadmap />
        <Curriculum />
        <Host />
        <Transformation />
        <Takeaways />
        <FAQ />
        <FinalRegister />
      </main>
      <Footer />
      <MobileCTA heroFormId="hero-form-anchor" />
    </div>
  );
}
